// src/config/seo.js
const SEO_CONFIG = {
  // Agent Information
  AGENT_NAME: "Sandy Hopkins",
  AGENT_EMAIL: "maricopasandy@gmail.com", 
  AGENT_PHONE: "+1-520-213-3096",
  
  // Business Address
  STREET_ADDRESS: "",
  CITY: "Maricopa",
  STATE: "AZ",
  ZIP_CODE: "", 
  COUNTRY: "US",
  
  // Geographic Coordinates
  LATITUDE: "33.0581",
  LONGITUDE: "-112.0476",
  
  // Domain & URLs
  DOMAIN: "https://sandyhopkins.com",
  
  // Social Media
  FACEBOOK_URL: "https://www.facebook.com/sandy.hopkins",
  TWITTER_HANDLE: "",
  LINKEDIN_URL: "",
  
  // Images  
  OG_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/raw-s-hopkins.png",
  TWITTER_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/raw-s-hopkins.png",
  LOGO_URL: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/raw-s-hopkins.png"
};

module.exports = { SEO_CONFIG };
